<template>
  <Modal v-if="showModal" @close="$emit('closeModal')">
    <div class="deleteReservation">
      <div class="deleteReservation__header">
        <span class="title">{{ $t('deleteReservation') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="$emit('closeModal')"
        />
      </div>
      <div class="deleteReservation__body">
        <p class="text">
          {{ $t('descriptionDestroy') }}
        </p>
        <p class="text">
          {{ $t('descriptionDelete') }}
        </p>

        <p class="text">
          {{ $t('descriptionCancel') }}
        </p>
      </div>
      <div class="deleteReservation__buttons">
        <Button
          variant="redButton"
          :title="$t('destroyed')"
          @click="$emit('destroyReservationRequest')"
        />
        <Button
          variant="yellowButton"
          :title="$t('delete')"
          @click="$emit('deleteReservationRequest')"
        />

        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'DeleteReservation',
  props: ['showModal']
})
export default class DeleteReservation extends Vue {}
</script>

<style lang="scss" scoped>
.deleteReservation {
  width: 460px;
  height: 100%;
  padding: 24px;
  .deleteReservation__header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .deleteReservation__body {
    padding: 24px 0;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
  .deleteReservation__buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>
